
// 中文配置
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { defineComponent, ref } from "vue";
import { message } from 'ant-design-vue';

// 类型检测
function typeString(obj) {
  var str = Object.prototype.toString.call(obj).replace(/[\[\]]/g, "");
  return str.split(" ")[1];
}

export default defineComponent({
  name: "alpMultiText",
  watch: {
    value: function (val) {
      if (val !== this.multiText) {
        this.multiText = val;
      }
    },
    multiText: function (val) {
      // console.log(val)
      // 更新值
      this.$emit('update:value', val);
      this.$emit("change", val);
    },
  },
  created: function () {
    this.multiText = this.value;
  },
  emits: ['change', 'update:value'],
  props: {
    value: String,
    placeholder: String,
    disabled: Boolean,
    a_attr: Object,
    a_event: Object,
    maxLimit: Number,
  },
  setup: function () {
    return {
      zhCN,
    };
  },
  data: function () {
    return {
      multiText: <any>"",
      // maxLimit: "",
      multiTextPopup: {
        show: false,
        data: <any>[],
        showData: [] ,
        i:1,
        page: 0,
        total: 0,
        size: 15,
        popupWidth: 300,
      },
    };
  },
  methods: {
    // 多行文本粘贴
    multiTextPaste: function (e) {
      setTimeout(() => {
        // 获取粘贴内容
        var pasteText = e.target.value;
        var newText = pasteText.replace(/[，\s]/gi, ",");
        var newTextArr = <any>[...new Set(newText.split(","))];

        if(this.maxLimit){
          // for (var i = newTextArr.length - 1; i >= 0; i--) {
          //   if (!newTextArr[i].length) {
          //     newTextArr.splice(i, 1);
          //   }
          // }
          if (newTextArr.length > this.maxLimit) {
            message.warning("最多支持" + this.maxLimit + "行，已保留前" +this.maxLimit +"行");
          }
          this.multiText = newTextArr.slice(0, this.maxLimit).join(",");
        }else{
          this.multiText = newTextArr.join(",");
        } 

      }, 200);
    },
    // 多行文本编辑弹窗
    multiTextPopupOpen: function () {
      if (
        typeof(this.multiText) == "string" &&
        this.multiText.length
      ) {
        var valueStr = this.multiText;
        valueStr = valueStr.replace("，", ",");
        var strArr = valueStr.split(",");
        strArr = strArr.slice(0, this.maxLimit);
        this.multiTextPopup.page = 0;
        this.multiTextPopup.i = 1;
        this.multiTextPopup.data = strArr.map((s) => {
          return {
            idx: this.multiTextPopup.i++,
            value: s,
          };
        });
        this.multiTextPopup.total = Math.ceil(
          this.multiTextPopup.data.length / this.multiTextPopup.size
        );
        // 展示数据
        this.multiTextPopup.showData = this.multiTextPopup.data.slice(
          this.multiTextPopup.page * this.multiTextPopup.size,
          (this.multiTextPopup.page + 1) * this.multiTextPopup.size
        );
      } else {
        this.multiTextPopup.i = 1;
        this.multiTextPopup.page = 0;
        this.multiTextPopup.total = 0;
        this.multiTextPopup.data = [];
        this.multiTextPopup.showData = [];
      }
    },
    // 多行文本编辑弹窗操作
    multiTextPopupOptions: function (type, idx) {
      switch (type) {
        case "clearAll":
          this.multiTextPopup.i = 1;
          this.multiTextPopup.page = 0;
          this.multiTextPopup.total = 0;
          this.multiTextPopup.data = [];
          this.multiTextPopup.showData = [];
          break;
        case "add":
          if (this.maxLimit && this.multiTextPopup.data.length > this.maxLimit) {
            message.warning("最多支持" + this.maxLimit + "行，已保留前" +this.maxLimit +"行");
            return;
          }
          this.multiTextPopup.data.push({
            idx: this.multiTextPopup.i++,
            value: "",
          });
          // 展示数据
          this.multiTextPopup.showData = this.multiTextPopup.data.slice(
            this.multiTextPopup.page * this.multiTextPopup.size,
            (this.multiTextPopup.page + 1) * this.multiTextPopup.size
          );

          this.multiTextPopup.total = Math.ceil(
            this.multiTextPopup.data.length / this.multiTextPopup.size
          );
          break;
        case "submit":
          var data = this.multiTextPopup.data.map((o) => o.value.trim());
          data = data.slice(0, this.maxLimit);
          this.multiText = data.join(",");
          this.multiTextPopup.i = 1;
          this.multiTextPopup.page = 0;
          this.multiTextPopup.total = 0;
          this.multiTextPopup.data = [];
          this.multiTextPopup.showData = [];
          this.multiTextPopup.show = false;
          // this.searchKeyChange("textarea");
          break;
        case "row:delete":
          // 删除数据
          for (var i = this.multiTextPopup.data.length - 1; i >= 0; i--) {
            var one = this.multiTextPopup.data[i];
            if (one.idx == idx) {
              this.multiTextPopup.data.splice(i, 1);
              break;
            }
          }
          // 更新数据
          this.multiTextPopup.showData = this.multiTextPopup.data.slice(
            this.multiTextPopup.page * this.multiTextPopup.size,
            (this.multiTextPopup.page + 1) * this.multiTextPopup.size
          );

          this.multiTextPopup.total = Math.ceil(
            this.multiTextPopup.data.length / this.multiTextPopup.size
          );
          break;
      }
    },
    // 多行文本编辑  分页
    multiTextPage: function(type){
      switch(type){
        case 'up':
          if(this.multiTextPopup.page>0){
            // 保存原数据
            this.multiTextPopup.data.splice(this.multiTextPopup.page*this.multiTextPopup.size, this.multiTextPopup.size, ...this.multiTextPopup.showData);

            this.multiTextPopup.page--;
            // 展示数据
            this.multiTextPopup.showData = this.multiTextPopup.data.slice(this.multiTextPopup.page*this.multiTextPopup.size, (this.multiTextPopup.page+1)*this.multiTextPopup.size);
          }
          break;
        case 'down':
          if(this.multiTextPopup.page<(this.multiTextPopup.total-1)){
            // 保存原数据
            this.multiTextPopup.data.splice(this.multiTextPopup.page*this.multiTextPopup.size, this.multiTextPopup.size, ...this.multiTextPopup.showData);
            
            this.multiTextPopup.page++;
            // 展示数据
            this.multiTextPopup.showData = this.multiTextPopup.data.slice(this.multiTextPopup.page*this.multiTextPopup.size, (this.multiTextPopup.page+1)*this.multiTextPopup.size);
          }
          break;
      }
    },
    // 多行文本编辑 输入回车
    multiTextInputEnter: function (e) {
      if (e.keyCode == 13) {
        this.multiText += ",";
      }
    },
  },
});
